<template>
  <div class="my-table userPage">
    <!-- 面包屑组件 -->
    <div class="searchBox flexCenter">
      <div class="current-location">
        <img class="location" src="@/assets/picture/icon/location.png">
        <span>{{$t('editRole.txt1')}}</span>
        <span>{{$t('editRole.txt2')}} / {{$t('editRole.txt3')}}</span>
      </div>
    </div>
    <!-- 面包屑 -->
    <el-card class="tableCard p30">
      <div class="contactTitle flexCenter mb50">
        <span>{{$t('editRole.txt3')}}</span>
        <div class="flexEnd">
          <div class="onCancelBtn mr30" @click="onBack">{{$t('editRole.txt4')}}</div>
          <div class="searchBtn" @click="confirmRole('editRoleForm')">确定</div>
        </div>
      </div>
      <div class="editForm passwordForm">
        <el-form :model="editRoleForm" :rules="editRoleRules" ref="editRoleForm" label-width="100px" class="demo-ruleForm">
          <el-form-item :label="$t('editRole.txt6')" prop="roleIds">
            <el-select v-model="editRoleForm.roleIds" :placeholder="$t('editRole.txt7')">
              <el-option
              v-for="item in roleOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
  </el-card>
</div>
</template>

<script>
  import qs from 'qs';
  export default {
    data() {
      return {
        roleOptions:[],
        editRoleForm:{
          roleIds:this.$route.query.roleIds,
          userId:this.$route.query.id
        },//修改角色参数
        // 修改角色规则
        editRoleRules: {
          roleIds: [
          { required: true, message: this.$t('editRole.txt7'), trigger: 'change' },
          ],
        },
      };
    },
    created() {
      this.getRoleList();
    },
    methods: {
      onBack(){
        this.$router.go(-1);
      },
    // 获取所有角色
    async getRoleList(){
      const { data: res } = await this.$http.post("/role/list");
      if(!res.success){
        return this.$message.error(res.message);
      }
      let list = res.result;
      this.roleOptions = [];
      list.map(e=>{
        let item = {
          value:e.id,
          label:e.roleName
        }
        this.roleOptions.push(item);
      })
    },
    // 修改用户角色
      confirmRole(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.editRole();
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
          // 用户编辑角色
      async editRole(){
        let data = {
          userId:this.editRoleForm.userId,
          roleIds:this.editRoleForm.roleIds,
        }
        const { data: res } = await this.$http.post("/user/info/add/role?"+qs.stringify(data));
        if(!res.success){
          return this.$message.error(res.message);
        }
        this.onBack();
      },
  },
};
</script>

<style lang="less" scoped>

  .handleBtn{
    padding: 0;
  }
  .userPage{
    /deep/ .el-upload__input{
      display: none !important;
    }
    /deep/ .el-date-editor .el-range-separator{
      margin-top: -5px;
      width: 8%;
    }
    .contactTitle{
      margin-bottom: 40px;
    }
    .contactTitle span{
      margin-right: 30px;
      cursor: pointer;
      font-size: 30px;
      font-weight: 500;
      color: #222222;
    }
    .w350{
      width: 350px;
    }
    .tips{      
      font-size: 1.4rem;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #98B9FF;
      margin-top: -10px;
    }
    .passwordForm{
      width: 50%;
      margin: 30px auto 260px auto;
      display: block;
    }
  }

</style>
